import { render, staticRenderFns } from "./topTip.vue?vue&type=template&id=08fe5bbc&"
import script from "./topTip.vue?vue&type=script&lang=js&"
export * from "./topTip.vue?vue&type=script&lang=js&"
import style0 from "./topTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports